import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

import FilterApp from './FilterApp';

if( document.querySelector('#listing-app') !== null) {
    ReactDOM.render(
        <FilterApp
            url={$('#api-json').data('url')}
            itemType={$('#api-json').data('tile-type')}
            itemContainerLayout={$('#api-json').data('tile-container-layout')} />,
        document.querySelector('#listing-app')
    );
}



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/index.jsx
 **/